import React from 'react';
import { useLocation } from 'react-router-dom';
import chatUnreadTotal from '@/function/conversation/chat/chat.unread.total';
import { selectSessionUser } from '@/store/auth/auth.selectors';
import { useListChatChannelsQuery } from '@/store/api/conversation/chat/chat.api';
import { useAppSelector } from '@/store/store.hooks';

const CHAT_PATH = /^\/conversations\/chat\/([^/]+)/;

export function useChatUnreadBadge(): Record<string, number> {
    const me = useAppSelector(selectSessionUser)?.authUserId ?? null;
    const location = useLocation();
    const { data } = useListChatChannelsQuery(undefined, { skip: !me });
    const active = CHAT_PATH.exec(location.pathname)?.[1] ?? null;
    return React.useMemo<Record<string, number>>(() => {
        const { total } = chatUnreadTotal((data?.channels ?? []).filter((channel) => channel.id !== active));
        const badges: Record<string, number> = {};
        if (total) {
            badges['conversations.chat'] = total;
            badges.conversations = total;
        }
        return badges;
    }, [data, active]);
}

export default useChatUnreadBadge;
